import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/views/payroll/directive.js';
import { mapState } from 'vuex';
// 更换管理员
import ReplaceManger from './modal/replace-manager';
import upload from '@/components/upload';
// 接口api
import { dismissCompany, modifybase, saveAudit as _saveAudit } from 'api/settings';
import { companyIndustries, companySize } from 'api/login';
import { utilCookies } from '@/util/cookies';
import { companyAdd, companyAddEn } from './config';
import { currentSession as _currentSession } from 'api/common';
var auditStatus = function auditStatus($t) {
  return new Map([[0, $t('1203')],
  // 未提交
  [1, $t('1204')],
  // 待审核
  [2, $t('1206')],
  // 已通过
  [3, $t('1205')] // 已拒绝
  ]);
};

export default {
  components: {
    ReplaceManger: ReplaceManger,
    upload: upload
  },
  data: function data() {
    return {
      saveState: false,
      // 是否修改
      modifyState: true,
      // 行业列表
      industries: [],
      // 规模列表
      size: [],
      currentCompany: {
        sa_info: {}
      },
      fileFormat: ['.png', '.jpg', '.jpeg'],
      // 认证状态
      auditStatus: auditStatus(this.$t),
      // form
      form: {
        c_name: '',
        c_license: ''
      },
      rules: {
        c_name: [{
          required: true,
          message: this.$t('314'),
          trigger: 'blur'
        }],
        c_license: [{
          required: true,
          message: this.$t('1207'),
          trigger: 'blur'
        }]
      },
      companyAdd: companyAdd(this),
      companyAddEn: companyAddEn(this),
      isShow: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    company_info: function company_info(state) {
      return state.user.company_info;
    }
  })), {}, {
    // 认证状态文案
    auditStatusType: function auditStatusType() {
      return this.auditStatus.get(Number(this.company_info.audit_status));
    },
    // 是否可以提交认证
    disabled: function disabled() {
      var status = Number(this.company_info.audit_status);
      return status === 1 || status === 2;
    }
  }),
  created: function created() {
    var _this = this;
    // 行业
    companyIndustries().then(function (res) {
      _this.industries = res.data;
    });
    // 规模
    companySize().then(function (res) {
      _this.size = res.data;
    });
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      this.currentCompany = this.$s.get('currentCompany');
      console.log(this.currentCompany);
      this.form = this.currentCompany.audit_info;
    },
    openReplace: function openReplace() {
      this.$refs.replace.init(true, this.currentCompany.sa_info ? this.currentCompany.sa_info.mobile : '');
    },
    changeState: function changeState() {
      this.modifyState = !this.modifyState;
    },
    handleShow: function handleShow() {
      this.isShow = !this.isShow;
    },
    // 解散公司
    handleDismissCompany: function handleDismissCompany() {
      this.$confirm(this.$t('824'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        dismissCompany().then(function () {
          utilCookies.removeToken();
          utilCookies.removeCompanyToken();
          window.location.reload();
        });
      });
    },
    // 修改基础信息
    modifyBaseInfo: function modifyBaseInfo() {
      var _this2 = this;
      this.$refs.currentForm.validate(function (valid) {
        if (valid) {
          if (_this2.currentCompany.branch_no && _this2.currentCompany.branch_no.length > 5) {
            _this2.$message.error(_this2.$t('1254'));
            return false;
          }
          if (_this2.currentCompany.postcode && _this2.currentCompany.postcode.length > 5) {
            _this2.$message.error(_this2.$t('1255'));
            return false;
          }
          modifybase(_this2.currentCompany).then(function (res) {
            if (res && res.code === 1) {
              _this2.$message.success(res.message);
              // this.$s.set('currentCompany', this.currentCompany)
              _this2.currentSession();
              _this2.saveState = false;
            }
          });
        }
      });
    },
    // 认证状态提交
    saveAudit: function saveAudit() {
      var _this3 = this;
      this.$refs.form.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 5;
                  break;
                }
                _context.next = 3;
                return _saveAudit(_this3.form);
              case 3:
                _this3.$notify.success({
                  title: _this3.$t('229'),
                  message: _this3.$t('886')
                });
                window.location.reload();
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    uploadSuccess: function uploadSuccess(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        val = _ref3[0];
      if (val && val.object_url) this.currentCompany.logo_url = val.object_url;
    },
    currentSession: function currentSession() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$_currentSessio, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _currentSession();
            case 2:
              _yield$_currentSessio = _context2.sent;
              data = _yield$_currentSessio.data;
              _this4.$store.dispatch('permission/setPermissionList', data.permissions);
              _this4.$store.dispatch('user/setUserInfo', data.user_info);
              _this4.$store.commit('user/COMPANY_INFO', data.company_info);
              _this4.$s.set('currentCompany', data.company_info);
              _this4.$s.set('userInfo', data.user_info);
              _this4.init();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};